export const homeObjOne = {
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: '¡Descuentos Exclusivos! 🔮',
  headline: 'Creamos tu Página Web 🤓💻',
  description:
    '¡Haz crecer tu negocio con nosotros, creamos la página web de tu negocio a corde a tus necesidades! 🙌🏻',
  buttonLabel: 'Comenzar',
  imgStart: '',
  img: 'https://cdn-icons-png.flaticon.com/512/4481/4481273.png',
  alt: 'Credit Card'
};

export const homeObjTwo = {
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: 'COTIZA',
  headline: '¡Contáctanos! 👨🏻‍💻',
  description:
    'Si ya tienes una idea de lo que buscas y necesitas, ¡Lo hacemos realidad! 🎉. \n\n Contactanos aquí con los siguientes enlaces 👇',
  buttonLabel: 'Contacto',
  imgStart: '',
  img: 'https://cdn-icons-png.flaticon.com/512/4481/4481293.png',
  alt: 'Vault'
};

export const homeObjThree = {
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: 'Rápido y Fácil',
  headline: 'Nuestro catalogo 🎴',
  description:
    "Tenemos una variedad de ejemplos de páginas web, puedes inspirarte en alguna y ¡Nosotros lo adaptamos a tus necesidades! 😎",
  buttonLabel: 'Ver',
  imgStart: 'start',
  img: 'https://cdn-icons-png.flaticon.com/512/4481/4481144.png',
  alt: 'Vault'
};

export const homeObjFour = {
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: 'DATA ANALYTICS',
  headline: 'Every transaction is stored on our secure cloud database',
  description:
    'Never ever have to worry again about saved reciepts. We store your data, so you can access it anytime.',
  buttonLabel: 'Sign Up Now',
  imgStart: 'start',
  img: 'images/svg-8.svg',
  alt: 'Vault'
};
